export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;


export const IMAGE_BASE_DIRECTORY = "images";
export const EDITOR_IMAGE_BASE_DIRECTORY = "editor_images";
export const CATEGORY_IMAGE_BASE_DIRECTORY = "icons";
export const ONBOARDING_IMAGE_BASE_DIRECTORY = "onboarding";
export const UPLOADS_COLLECTION_NAME = 'uploads';
export const UPLOADS_ONBOARDING_SOURCE = 'onboarding';
export const UPLOADS_CATEGORY_SOURCE = 'category';
export const UPLOADS_CONTENT_COVER_SOURCE = 'content_cover';
export const UPLOADS_CONTENT_EDITOR_SOURCE = 'content_editor_image';
export const UPLOADS_CONTENT_VIDEO_SOURCE = 'content_video';
export const UPLOADS_CONTENT_PODCAST_SOURCE = 'content_podcast';
export const UPLOADS_IMAGE_TYPE = 'image';
export const UPLOADS_CONTENT_VIDEO_TYPE = 'video';
export const UPLOADS_CONTENT_PODCAST_TYPE = 'podcast';
export const VIDEO_BASE_DIRECTORY = "videos";
export const PODCAST_BASE_DIRECTORY = "audios";
export const UPLOADS_INPROGRESS_STATUS = 'in_progress';
export const UPLOADS_UPLOADED_STATUS = 'uploaded';
export const UPLOADS_CANCEL_STATUS = 'cancelled';
export const UPLOADS_ERROR_STATUS = 'error';
export const UPLOADS_COMPLETED_STATUS = 'completed';
export const UPLOADS_ARCHIVED_STATUS = 'archived';
